var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDynamicGreetingX = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "186.4%",
    height: "186.4%",
    x: "-43.2%",
    y: "-43.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 2,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M18 7c6.076 0 11 4.925 11 11s-4.924 11-11 11c-6.075 0-11-4.925-11-11S11.925 7 18 7Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "#000",
    filter: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00818C",
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M30 18c0 3.314-1.343 6.314-3.515 8.485A11.962 11.962 0 0 1 18 30a11.962 11.962 0 0 1-8.485-3.515A11.962 11.962 0 0 1 6 18c0-3.314 1.343-6.314 3.515-8.485A11.962 11.962 0 0 1 18 6c3.314 0 6.314 1.343 8.485 3.515A11.963 11.963 0 0 1 30 18Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14.495 22.712 22.217 14M22.712 22.217 14 14.495"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDynamicGreetingX);
export default ForwardRef;